export default __webpack_public_path__ + "static/media/quatroqueijos.88b4e7a6.jpg";